import { Link, useLocation as useRouterLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import styles from './IvSubnav.module.css';

export const IV_BASE = '/insurance-verification';

interface SubnavItem {
  label: string;
  path: string;
  /** Extra prefix that keeps this item active (e.g. detail pages under the worklist). */
  alsoMatchPrefix?: string;
}

const ITEMS: SubnavItem[] = [
  { label: 'Worklist', path: IV_BASE, alsoMatchPrefix: `${IV_BASE}/verifications` },
  { label: 'Import schedule', path: `${IV_BASE}/import` },
  { label: 'Templates', path: `${IV_BASE}/templates` },
  // Practice credentials and Connections are in Settings > Operations.
  { label: 'Settings', path: '/settings/operations' },
];

export function IvSubnav() {
  const { pathname } = useRouterLocation();

  return (
    <nav className={styles.subnav} aria-label="Insurance verification">
      {ITEMS.map((item) => {
        const active =
          pathname === item.path ||
          (!!item.alsoMatchPrefix && pathname.startsWith(item.alsoMatchPrefix));
        return (
          <Link
            key={item.path}
            to={item.path}
            className={clsx(styles.item, active && styles.itemActive)}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
